import { gdImgSrcPolicy } from "@/utils/imageUrl";
import { useCountDown } from "ahooks";
import { Button } from "antd";
import { useMemo } from "react";
import HBModal from "../HBModal";
import ModalWrap from "../HBModal/ModalWrap";
import Image from "../Image";
import styles from "./index.module.less";
function RawCounponModal({
  duration,
  btnText = "立即使用",
  onOk,
  imgUrl,
  ...props
}) {
  const targetDate = useMemo(() => {
    return Date.now() + (duration || 1) * 24 * 3600 * 1000;
  }, [duration]);

  const [countdown, formattedRes] = useCountDown({
    targetDate,
  });
  return (
    <HBModal
      className={styles.modal}
      footer={null}
      {...props}
      width={480}
      maskClosable={false}
    >
      <div
        className={styles.content}
        data-dialog-title="挽留弹窗_优惠券"
        data-gd-expose="dialog_expose"
      >
        <Image
          width={480}
          alt={"优惠券背景"}
          {...gdImgSrcPolicy(imgUrl, {
            displayWidth: 480,
            type: "png",
          })}
        />
        <div className={styles.footer}>
          {countdown > 0 ? (
            <div className={styles.countdown}>
              有效期仅剩
              <span className={styles.time}>
                <span>{formattedRes.hours}</span>:
                <span>{formattedRes.minutes}</span>:
                <span>{formattedRes.seconds}</span>
              </span>
              请尽快使用
            </div>
          ) : (
            <div className={styles.countdown}>已过期</div>
          )}
          <Button
            type="primary"
            onClick={onOk}
            data-dialog-title="挽留弹窗_优惠券"
            data-gd-click="dialog_action"
            data-dialog-action="立即使用"
          >
            {btnText}
          </Button>
        </div>
      </div>
    </HBModal>
  );
}

const CounponModal = ModalWrap(RawCounponModal);

export default CounponModal;
